/**
 * Local ENU tangent frame over an operational patch.
 * x = east, y = north on the tangent plane. The persisted `altitude` name stores
 * absolute Three.js world-Y for compatibility; it is not a player-controlled axis.
 * Cube-sphere planet representation is deferred past the procedural gate.
 */

export type EnuPosition = {
  x: number;
  y: number;
  altitude: number;
};

export function enuDistance(a: EnuPosition, b: EnuPosition): number {
  return Math.hypot(a.x - b.x, a.y - b.y);
}

export function chunkKey(cx: number, cy: number): string {
  return `${cx},${cy}`;
}

export function worldToChunk(x: number, y: number, chunkSize: number): { cx: number; cy: number } {
  return {
    cx: Math.floor(x / chunkSize),
    cy: Math.floor(y / chunkSize),
  };
}
